
    //Countdown Clock Banner Code for Black Friday 2019

    // Set the dates we're counting down to
    var blackFridaycountDownDate = new Date("Dec 2, 2019 04:59:59").getTime();
    var cyberMondaycountDownDate = new Date("Dec 3, 2019 04:59:59").getTime();
    var CMExtensioncountDownDate = new Date("Dec 6, 2019 04:59:59").getTime();

    // Get today's date and time
    var now = new Date().toLocaleString("en-US", {timeZone: "UTC"});
    now = new Date(now).getTime();
    var countDownDate = CMExtensioncountDownDate;
    if(now < cyberMondaycountDownDate) {
        countDownDate = cyberMondaycountDownDate;
    }
    if(now < blackFridaycountDownDate) {
        countDownDate = blackFridaycountDownDate;
    }

        // Update the count down every 1 second
        var x = setInterval(function () {

            // Find the distance between now and the count down date
            now = new Date().toLocaleString("en-US", {timeZone: "UTC"});
            now = new Date(now).getTime();
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // If the countdown is finished, write some text
            if (distance == 0) {
                clearInterval(x);
            }

            //Set text to be plural iff there are multiple of that type
            var dayText = days === 1 ? " day, " : " days, ";
            var hourText = hours === 1 ? " hour, " : " hours, ";
            var minuteText = minutes === 1 ? " minute, " : " minutes, ";
            var secondText = seconds === 1 ? " second." : " seconds.";

            //If the clock exists, then we must update it
            if(document.getElementById("countdown-clock")) {
                // Display the result in the element
                document.getElementById("countdown-clock").innerHTML = days + dayText + hours + hourText
                    + minutes + minuteText + seconds + secondText;
            }

        }, 1000);

